import { render, staticRenderFns } from "./SignalTokenBurn.vue?vue&type=template&id=124d7b61&scoped=true&"
import script from "./SignalTokenBurn.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalTokenBurn.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d7b61",
  null
  
)

export default component.exports